import { render, staticRenderFns } from "./MessengerSideBar.vue?vue&type=template&id=29117fc0"
import script from "./MessengerSideBar.vue?vue&type=script&lang=js"
export * from "./MessengerSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports